<template>
  <OverlayCard :close-button="false" width="m" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('licensing.trialNoticeCard.text.title', daysLeft) }}
    </template>

    <template #content>
      <p>{{ $t('licensing.trialNoticeCard.text.main') }}</p>

      <p>{{ $t('licensing.text.training') }}</p>
    </template>

    <template #footer>
      <LicenseUpgradeAction />
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LicenseUpgradeAction from './LicenseUpgradeAction.vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'LicenseTrialNoticeCard',

  components: {
    LicenseUpgradeAction,
  },

  props: {
    daysLeft: {
      type: Number,
      required: true,
    },
  },
});
</script>
